exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-3fc57f52] .el-descriptions-row:hover {\r\n\tbackground-color: #fff;\n}\r\n", ""]);

// exports
